import React from 'react';
import FormBuilderProvider from "./context/form-builder-context.jsx";
import FormBuilder from "./components/form-builder.jsx";

const FormBuilderPage = () => {
    return (
        <FormBuilderProvider>
            <FormBuilder />
        </FormBuilderProvider>
    );
};

export default FormBuilderPage;